<template>
    <div class="mobile-menu-shell">
        <div
            class="mobile-menu-backdrop"
            @click="toggleMenu('close')"
            aria-hidden="true"
        ></div>
        <div id="menu-mobile">
            <IconCross @click.prevent="toggleMenu('close')" />
            <BzioupLogo
                to="/"
                :src="logo?.image?.url"
            />
            <ul>
                <li
                    v-for="menu in menus"
                    v-bind:key="menu.id"
                >
                    <Link
                        :to="menu.url"
                        :label="menu.label"
                        :style="menu.style"
                    />
                </li>
            </ul>
            <div class="mobile-stores-teaser">
                <Link
                    v-for="button in buttons"
                    :to="button.url"
                    :label="button.label"
                    :style="button.style"
                    :image="button.image"
                    v-bind:key="button.id"
                />
            </div>
            <router-link
                class="btn-pill btn-pill--pink menu-cta"
                :to="{ path: '/', hash: '#get-the-app' }"
            >
                <span aria-hidden="true">🖤</span>
                {{ getAppLabel }}
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapState } from 'pinia'
import { useStore } from '@/stores/index'
import { getHomeContent } from '@/data/home'
import BzioupLogo from '@/components/Logos/Bzioup.vue'
import Link from '@/components/Links/Link.vue'
import IconCross from '@/components/Icons/Cross.vue'

export default {
    name: 'MainMobileMenu',
    components: {
        BzioupLogo,
        Link,
        IconCross
    },
    props: {
        logo: Object,
        menus: Object,
        buttons: Object,
        toggleMenu: Function
    },
    computed: {
        ...mapState(useStore, ['language']),
        getAppLabel() {
            return getHomeContent(this.language).nav.getApp
        },
    },
    watch: {
        // Close the mobile menu whenever the route changes. covers clicks on
        // the menu links, the logo, store badges, anything navigation-driven.
        $route() {
            this.toggleMenu('close')
        }
    }
}
</script>

<style lang="scss">
/* Full-viewport shell. wraps the backdrop + the actual menu panel.
   The slide transition (in Header.vue) is applied to this root element. */
.mobile-menu-shell {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
}

/* Click-anywhere-to-close overlay sitting behind the menu panel.
   Subtle dim so the menu reads as elevated above the page. */
.mobile-menu-backdrop {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.3);
    cursor: pointer;
}

#menu-mobile {
    position: absolute;
    top: 0;
    left: 20%;     /* max 80% viewport width */
    right: 0;
    bottom: 0;
    background-color: var(--bzioup-bg-color-B);
    overflow: hidden;
    flex-direction: column;
    padding: 30px 20px;

    .close {
        top: 10px;
        font-size: 28px;
    }

    ul {
        text-align: left;
        list-style-type: none;
        padding-inline-start: 0px;

        li {
            margin: 20px 0px;
        }
    }

    >div a {
        display: block;
        margin: 20px 0px;
    }

    .menu-cta {
        display: inline-flex;
        margin-top: 10px;
    }
}

@media (min-width: $mq-small) {
    #menu-mobile {
        left: 30%;
    }
}
</style>